import { Grid, Tabs, Tab, Card, CardActionArea, CardMedia, CardContent, Typography, Grow, Dialog, DialogTitle, DialogActions, DialogContent } from '@mui/material';
import React, { useState } from 'react';
import useData from '../../Hooks/useData';
import { TitleSection } from '../Resume/Resume';
import { FaGithub,FaExternalLinkAlt } from 'react-icons/fa'
import './Protfolio.css'

const Protfolio = () => {
    const { allProjects } = useData()
    const [ tabValue, setTabValue ] = useState("All")
    const [projectDailog, setProjectDailog] = useState(false)

   
    return (
        <Grid container>
            <Grid item >
                <TitleSection text={"Protfolio"} />
            </Grid>

            {/* Tabs */}
            <Grid item xs={12}>
                <Tabs value={tabValue} indicatorColor="white" className="customTabs" onChange={(event, newValue) => setTabValue(newValue)}>
                    <Tab label="All" value="All" className={tabValue === "All" ? 'customTabs-item active' : 'customTabs-item'}></Tab>
                    {[...new Set(allProjects?.map(item => item.tag))].map(tag => (
                        <Tab label={tag} value={tag} className={tabValue === tag ? 'customTabs-item active' : 'customTabs-item'}></Tab>
                    ))}
                </Tabs>
            </Grid>
            {/* Projects */}
            <Grid item xs={12}>
                <Grid container spacing={2}>
                    {allProjects?.map(project => (
                        <>
                            {tabValue === project.tag || tabValue === 'All' ? (
                                <Grid item md={6} >
                                    <Grow in timeout={1000}>
                                        <Card style={{backgroundColor:"rgb(23, 42, 69)",color:"#fff"}} className="customCard" onClick={() =>setProjectDailog(project)}>
                                            <CardActionArea>
                                                <CardMedia className="customCard-img" image={project.image} title={project.title} />
                                                <CardContent>
                                                    <Typography variant="body2" className='customCard-title'>{project.title}</Typography><br />
                                                    <Typography variant="body2" className='customCard-desc small'>{project.desc.slice(0,100) + "..."}</Typography>
                                                    <br />
                                                    <div className="technology">
                                                        {project?.tech?.map(t=> <span>{t}</span> )}
                                                    </div>
                                                    <br />
                                                    <div className="">
                                                    {project.source && <a className="text-white me-3" href={project.source} target="_blank" rel="noopener noreferrer"><FaGithub></FaGithub></a>}
                                                    {project.live && <a className="text-white me-3" href={project.live} target="_blank" rel="noopener noreferrer"><FaExternalLinkAlt className=""></FaExternalLinkAlt></a>}
                                                        
                                                    </div>
                                                </CardContent>
                                            </CardActionArea>
                                        </Card>
                                    </Grow>
                                </Grid>
                            ) : null}

                        </>

                    ))}
                </Grid>
            </Grid>

            <Dialog open={projectDailog} onClose={() => setProjectDailog(false)} className="projectDialog">
                <DialogTitle onClick={() => setProjectDailog(false)}>
                   {projectDailog.title}
                </DialogTitle>
                <img src={projectDailog.image} className="projectDialog-image" alt="" />
                <DialogContent>
                    <Typography className="projectDialog-desc">{projectDailog.desc}</Typography>
                </DialogContent>
                <DialogActions className="projectDialog-action">
                    
                    {projectDailog.live && <a className="text-dark me-3 fs-3 projectDialog-link" href={projectDailog.live} target="_blank" rel="noopener noreferrer"><FaGithub></FaGithub></a>}

                    {projectDailog?.source && <a className="text-dark me-3 fs-4 projectDialog-link" href={projectDailog.source} target="_blank" rel="noopener noreferrer"><FaExternalLinkAlt></FaExternalLinkAlt></a>}

                    
                   
                </DialogActions>
            </Dialog>

        </Grid>
    );
};

export default Protfolio;